import { Box } from "@mui/material";
import { NextPage } from "next";

import { authPageContainer, authPageMain } from "@/components/page-auth/auth-page-styles";
import AuthFooterLinks from "@/components/page-auth/AuthFooterLinks";
import LoginContainer from "@/components/page-login/LoginContainer";

const Index: NextPage = () => {
  return (
    <Box css={authPageContainer}>
      <Box css={authPageMain}>
        <LoginContainer />
      </Box>
      <AuthFooterLinks />
    </Box>
  );
};

export default Index;

export const getServerSideProps = async () => ({
  props: { noHeader: true },
});
